import {
  CREATE_ACTION_ITEM_REQUEST,
  CREATE_NOTES_REQUEST,
  CREATE_PLAN_CATEGORY_REQUEST,
  CREATE_PLAN_REQUEST,
  CREATE_R_FILE_REQUEST,
  CREATE_TOOL_REQUEST,
  DELETE_ACTION_ITEM_REQUEST,
  DELETE_GOAL_REQUEST,
  DELETE_NOTES_REQUEST,
  DELETE_PLAN_CATEGORY_REQUEST,
  DELETE_R_FILE_REQUEST,
  DELETE_TOOL_REQUEST,
  GET_PLAN_BY_ID_REQUEST,
  GET_PLAN_REQUEST,
  REMOVE_PLAN_REQUEST,
  UPDATE_ACTION_ITEM_REQUEST,
  UPDATE_GOAL_REQUEST,
  UPDATE_NOTES_REQUEST,
  UPDATE_PLAN_CATEGORY_REQUEST,
  UPDATE_PLAN_REQUEST,
  UPDATE_RESOURCES_REQUEST,
  UPDATE_R_FILE_REQUEST,
  UPDATE_TOOL_REQUEST,
  CREATE_REMINDER_REQUEST,
  ARCHIVE_PLAN_REQUEST,
  ADJUST_CATEGORY_WEIGHT_REQUEST,
  GET_TOOL_REQUEST,
  CHANGE_ACTION_ITEM_ORDERS_REQUEST,
  CHANGE_PLAN_CATEGORY_ORDERS_REQUEST,
  CREATE_LABEL_AND_UNITS_REQUEST,
  CLONE_PLAN_REQUEST,
  GET_SHARED_PLAN_BY_ID_REQUEST,
  BULK_UPDATE_TOOL_REQUEST,
  GET_ALL_USER_REQUEST,
  UPDATE_COLLABORATOR_REQUEST,
  CREATE_REQUEST_ACCESS_REQUEST,
  CHANGE_CATEGORY_ORDERS_REQUEST,
  BULK_GOAL_UPDATE_REQUEST,
  UPADTE_GOAL_LABEL_REQUEST,
  GET_PROJECT_PREFERENCES_REQUEST,
  UPDATE_PROJECT_PREFERENCES_REQUEST,
  UPDATE_PROJECT_MANUAL_STATUS_REQUEST,
  CREATE_PROJECT_PREFERENCES_REQUEST,
  GET_GOAL_LIST_REQUEST,
  GET_GOAL_LIST_BY_ID_REQUEST,
  UPDATE_CUSTOMIZE_COLUMN_REQUEST,
  GET_CUSTOMIZE_COLUMN_REQUEST,
  CLEAR_SELECTED_GOAL_LIST,
  CREATE_NEW_ACTION_ITEM_REQUEST,
  UPLOAD_FILE_WITHOUT_PROJECTID_REQUEST,
  CREATE_PROJECT_PLAN_REQUEST,
  CLEAR_UPLOAD_FILE,
  BULK_UPDATE_PLAN_ACTION_CATEGORY_REQUEST,
  POST_METRIC_REQUEST,
  UPDATE_USER_TUTORIAL_REQUEST,
  UPDATE_CATEGORY_NAME_REQUEST,
  ADD_BULK_CATEGORY_REQUEST,
  UPDATE_BULK_ACTION_REQUEST,
  CREATE_PROJECT_WITH_WIZARD_REQUEST,
  BULK_ARIA_PROJECT_PLAN_REQUEST,
  GET_PREDEFINED_METRICS_REQUEST,
  NOTIFICATION_SETTING_REQUEST,
  GET_NOTIFICATION_SETTING_REQUEST,
  UPLOAD_CSV_REQUEST,
  UPDATE_CATEGORY_STATE_REQUEST,
  DUPLICATE_PLAN_REQUEST,
  CREATE_ACTION_ITEM_COMMENT_REQUEST,
  GET_ACTIVITY_LOG_REQUEST,
  GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_REQUEST,
  LIKE_COMMENT_REQUEST,
  UNLIKE_COMMENT_REQUEST,
  DELETE_COMMENT_REQUEST,
  UPDATE_COMMENT_REQUEST,
  REPLY_COMMENT_REQUEST,
  UPDATE_CUSTOMIZE_COLUMN_FROZEN_REQUEST,
  GET_CUSTOMIZE_COLUMN_FROZEN_REQUEST,
  UPDATE_VIEW_TYPE_REQUEST,
  VIEW_TYPE_LIST,
  SET_CUSTOMIZE_COLUMNS_STATE,
} from "../reducers/PlanReducer";

export const createPlan = (payload, closeModal, resetState) => ({
  type: CREATE_PLAN_REQUEST,
  payload,
  closeModal,
  resetState,
});

export const getPlans = (payload, spread, search) => ({
  type: GET_PLAN_REQUEST,
  payload: { payload, spread, search },
});

export const getPlanByID = (payload, callback, handleCancel) => ({
  type: GET_PLAN_BY_ID_REQUEST,
  payload,
  callback,
  handleCancel,
});

export const getSharedProjectByID = (payload, callback) => ({
  type: GET_SHARED_PLAN_BY_ID_REQUEST,
  payload,
  callback,
});

export const updatePlan = (id, payload, closeModal, noAlert) => ({
  type: UPDATE_PLAN_REQUEST,
  id,
  payload,
  closeModal,
  noAlert,
});

export const removePlan = (payload, goBack) => ({
  type: REMOVE_PLAN_REQUEST,
  payload,
  goBack,
});

export const archivePlan = (payload, goBack, closeModal) => ({
  type: ARCHIVE_PLAN_REQUEST,
  payload,
  goBack,
  closeModal,
});

export const createPlanCategory = (payload, removeNewList, handleError) => ({
  type: CREATE_PLAN_CATEGORY_REQUEST,
  payload,
  removeNewList,
  handleError,
});

export const updatePlanCategory = (
  id,
  payload,
  noAlert,
  closeModal,
  onError
) => ({
  type: UPDATE_PLAN_CATEGORY_REQUEST,
  id,
  payload,
  noAlert,
  closeModal,
  onError,
});

export const adjustCategoryWeight = (payload, project_plan, closeModal) => ({
  type: ADJUST_CATEGORY_WEIGHT_REQUEST,
  closeModal,
  project_plan,
  payload,
});

export const deletePlanCategory = (payload, project_plan, closeModal) => ({
  type: DELETE_PLAN_CATEGORY_REQUEST,
  payload,
  project_plan,
  closeModal,
});

export const createActionItem = (payload, goBack) => ({
  type: CREATE_ACTION_ITEM_REQUEST,
  payload,
  goBack,
});

export const updateCustomizeColumn = (payload) => ({
  type: UPDATE_CUSTOMIZE_COLUMN_REQUEST,
  payload,
});

export const updateCustomizeColumnFrozen = (payload) => ({
  type: UPDATE_CUSTOMIZE_COLUMN_FROZEN_REQUEST,
  payload,
});

export const getCustomizeColumn = (payload) => ({
  type: GET_CUSTOMIZE_COLUMN_REQUEST,
  payload,
});

export const getCustomizeColumnFrozen = (payload) => ({
  type: GET_CUSTOMIZE_COLUMN_FROZEN_REQUEST,
  payload,
});

export const updateActionItem = (
  id,
  payload,
  project_plan,
  noAlert,
  handleClose
) => ({
  type: UPDATE_ACTION_ITEM_REQUEST,
  id,
  project_plan,
  payload,
  noAlert,
  handleClose,
});

export const upateCategoryName = (id, payload, project_plan) => ({
  type: UPDATE_CATEGORY_NAME_REQUEST,
  id,
  project_plan,
  payload,
});

export const deleteActionItem = (payload, project_plan, closeModal, isTask = false, onError) => ({
  type: DELETE_ACTION_ITEM_REQUEST,
  payload,
  project_plan,
  closeModal,
  isTask,
  onError,
});

export const changeActionItemsOrder = (payload, project_plan) => ({
  type: CHANGE_ACTION_ITEM_ORDERS_REQUEST,
  payload,
  project_plan,
});

export const changeCategoryOrder = (payload, project_plan) => ({
  type: CHANGE_CATEGORY_ORDERS_REQUEST,
  payload,
  project_plan,
});

export const changeCategoryItemsOrder = (payload, project_plan) => ({
  type: CHANGE_PLAN_CATEGORY_ORDERS_REQUEST,
  payload,
  project_plan,
});

export const createNotes = (payload, project_plan, goBack) => ({
  type: CREATE_NOTES_REQUEST,
  payload,
  project_plan,
  goBack,
});

export const createNewActionItemsModal = (
  payload,
  project_plan,
  setActionItemsModal,
  handleClose,
  isTask = true,
  handleError
) => ({
  type: CREATE_NEW_ACTION_ITEM_REQUEST,
  payload,
  project_plan,
  setActionItemsModal,
  handleClose,
  isTask,
  handleError,
});

export const upateNotes = (id, payload, project_plan, callback) => ({
  type: UPDATE_NOTES_REQUEST,
  id,
  project_plan,
  payload,
  callback,
});

export const deleteNotes = (payload, project_plan, closeModal) => ({
  type: DELETE_NOTES_REQUEST,
  payload,
  project_plan,
  closeModal,
});

export const getTools = () => ({
  type: GET_TOOL_REQUEST,
});

export const getAllRequest = (payload) => ({
  type: GET_ALL_USER_REQUEST,
  payload,
});

export const updateRequest = (payload, id) => ({
  type: UPDATE_COLLABORATOR_REQUEST,
  payload,
  id,
});

export const createCollaboratorRequest = (payload, navigate) => ({
  type: CREATE_REQUEST_ACCESS_REQUEST,
  payload,
  navigate,
});

export const createTool = (payload, closeModal) => ({
  type: CREATE_TOOL_REQUEST,
  payload,
  closeModal,
});

export const bulkUpdateTool = (payload, id, closeModal) => ({
  type: BULK_UPDATE_TOOL_REQUEST,
  payload,
  id,
  closeModal,
});

export const upateTool = (id, payload, project_plan) => ({
  type: UPDATE_TOOL_REQUEST,
  id,
  project_plan,
  payload,
});

export const deleteTool = (payload, project_plan) => ({
  type: DELETE_TOOL_REQUEST,
  payload,
  project_plan,
});

export const createRFile = (payload, project_plan, closeModal) => ({
  type: CREATE_R_FILE_REQUEST,
  payload,
  project_plan,
  closeModal,
});

export const upateRFile = (id, payload, project_plan) => ({
  type: UPDATE_R_FILE_REQUEST,
  id,
  project_plan,
  payload,
});

export const updateResources = (
  id,
  payload,
  project_plan,
  closeModal,
  message
) => ({
  type: UPDATE_RESOURCES_REQUEST,
  id,
  project_plan,
  payload,
  closeModal,
  message,
});

export const deleteRFile = (payload, project_plan) => ({
  type: DELETE_R_FILE_REQUEST,
  payload,
  project_plan,
});

export const updateGoal = (id, payload, project_plan, key, handleClose) => ({
  type: UPDATE_GOAL_REQUEST,
  id,
  project_plan,
  payload,
  key,
  handleClose,
});

export const PostMetric = (payload, project_plan, handleClose) => ({
  type: POST_METRIC_REQUEST,
  payload,
  project_plan,
  handleClose,
});
export const blukUpdateGoal = (payload, project_plan, handleClose) => ({
  type: BULK_GOAL_UPDATE_REQUEST,
  payload,
  project_plan,
  handleClose,
});

export const updateGoalLabel = (payload) => ({
  type: UPADTE_GOAL_LABEL_REQUEST,
  payload,
});

export const deleteGoal = (id, project_plan) => ({
  type: DELETE_GOAL_REQUEST,
  id,
  project_plan,
});

export const createReminder = (payload, project_plan, closeModal) => ({
  type: CREATE_REMINDER_REQUEST,
  payload,
  project_plan,
  closeModal,
});

export const createCustomLabelAndUnits = (
  payload,
  selectedUnitValue,
  project_plan,
  closeModal
) => ({
  type: CREATE_LABEL_AND_UNITS_REQUEST,
  payload,
  project_plan,
  selectedUnitValue,
  closeModal,
});

export const clonePlan = (payload, callback) => ({
  type: CLONE_PLAN_REQUEST,
  payload,
  callback,
});

export const updateCategoryState = (id, payload) => ({
  type: UPDATE_CATEGORY_STATE_REQUEST,
  id,
  payload,
});

export const getGoalList = (payload) => ({
  type: GET_GOAL_LIST_REQUEST,
  payload,
});

export const getGoalListById = (payload) => ({
  type: GET_GOAL_LIST_BY_ID_REQUEST,
  payload,
});

export const clearSelectedGoalList = () => ({
  type: CLEAR_SELECTED_GOAL_LIST,
});

export const clearUploadFile = () => ({
  type: CLEAR_UPLOAD_FILE,
});

export const updateFile = (payload) => ({
  type: UPLOAD_FILE_WITHOUT_PROJECTID_REQUEST,
  payload,
});

export const createProjectPlan = (payload, closeModal) => ({
  type: CREATE_PROJECT_PLAN_REQUEST,
  payload,
  closeModal,
});

export const bulkUpdatePlanActionCategory = (payload, closeModal) => ({
  type: BULK_UPDATE_PLAN_ACTION_CATEGORY_REQUEST,
  payload,
  closeModal,
});

export const UpdateTutorial = (id, payload) => ({
  type: UPDATE_USER_TUTORIAL_REQUEST,
  id,
  payload,
});
export const getProjectPerferences = (payload) => ({
  type: GET_PROJECT_PREFERENCES_REQUEST,
  payload,
});

export const createProjectPerferences = (payload) => ({
  type: CREATE_PROJECT_PREFERENCES_REQUEST,
  payload,
});

export const updateProjectPerferences = (id, payload) => ({
  type: UPDATE_PROJECT_PREFERENCES_REQUEST,
  id,
  payload,
});

export const updateManualStatus = (
  id,
  payload,
  projectPlanId,
  handleClose
) => ({
  type: UPDATE_PROJECT_MANUAL_STATUS_REQUEST,
  id,
  payload,
  projectPlanId,
  handleClose,
});

export const addBulkCategory = (payload, project_plan, closeModal) => ({
  type: ADD_BULK_CATEGORY_REQUEST,
  payload,
  project_plan,
  closeModal,
});

export const updateBulkAction = (
  payload,
  project_plan,
  closeModal,
  handleError
) => ({
  type: UPDATE_BULK_ACTION_REQUEST,
  payload,
  project_plan,
  closeModal,
  handleError,
});

export const getPredefinedMetrics = () => ({
  type: GET_PREDEFINED_METRICS_REQUEST,
});

export const notificationSetting = (payload) => ({
  type: NOTIFICATION_SETTING_REQUEST,
  payload,
});

export const getNotificationSetting = (payload) => ({
  type: GET_NOTIFICATION_SETTING_REQUEST,
  payload,
});

export const CreateProjectWithWizard = (payload, closeModal) => ({
  type: CREATE_PROJECT_WITH_WIZARD_REQUEST,
  payload,
  closeModal,
});

export const BulkAriaProjectPlan = (payload, closeModal) => ({
  type: BULK_ARIA_PROJECT_PLAN_REQUEST,
  payload,
  closeModal,
});

export const uploadCSV = (payload, closeModal) => ({
  type: UPLOAD_CSV_REQUEST,
  payload,
  closeModal,
});

export const duplicatePlan = (payload, handleClose) => ({
  type: DUPLICATE_PLAN_REQUEST,
  payload: { ...payload, clone_type: payload.clone_type ?? "duplicate" },
  handleClose,
});

export const createActionItemComment = (payload, handleClose) => ({
  type: CREATE_ACTION_ITEM_COMMENT_REQUEST,
  payload,
  handleClose,
});

export const getActivityLog = (payload) => ({
  type: GET_ACTIVITY_LOG_REQUEST,
  payload,
});

export const getCommentOfSpecificActionItem = (payload) => ({
  type: GET_COMMENT_OF_SPECIFIC_ACTION_ITEM_REQUEST,
  payload,
});

export const likeComment = (payload, handleClose) => ({
  type: LIKE_COMMENT_REQUEST,
  payload,
  handleClose,
});

export const unlikeComment = (payload, handleClose) => ({
  type: UNLIKE_COMMENT_REQUEST,
  payload,
  handleClose,
});

export const deleteComment = (payload, handleClose) => ({
  type: DELETE_COMMENT_REQUEST,
  payload,
  handleClose,
});

export const updateComment = (id, payload, handleClose, isGetApi = true) => ({
  type: UPDATE_COMMENT_REQUEST,
  id,
  payload,
  handleClose,
  isGetApi,
});

export const replyComment = (payload, handleClose) => ({
  type: REPLY_COMMENT_REQUEST,
  payload,
  handleClose,
});

export const updateViewType = (id, payload) => ({
  type: UPDATE_VIEW_TYPE_REQUEST,
  id,
  payload,
});

export const updateViewTypeList = (payload) => ({
  type: VIEW_TYPE_LIST,
  payload,
});

export const setCustomizeColumnsState = (payload) => ({
  type: SET_CUSTOMIZE_COLUMNS_STATE,
  payload,
});
